module.exports = __webpack_public_path__ + "media/images/ui__textArrowDown-60105de491d2ea4bf69ad253e41fb33b.png";